"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConversationFilterSlaOptions = void 0;
var ConversationFilterSlaOptions;
(function (ConversationFilterSlaOptions) {
    ConversationFilterSlaOptions["HasSla"] = "has_sla";
    ConversationFilterSlaOptions["HasNotSla"] = "has_not_sla";
    ConversationFilterSlaOptions["Exceeded"] = "exceeded";
    ConversationFilterSlaOptions["NotExceeded"] = "not_exceeded";
})(ConversationFilterSlaOptions = exports.ConversationFilterSlaOptions || (exports.ConversationFilterSlaOptions = {}));
